// extracted by mini-css-extract-plugin
export var numberInputContainer = "_66-0";
export var startPickingButton = "_66-1";